module.exports = __webpack_public_path__ + "img/menu_img3.d4f3e08f.png";